import React from 'react';
import { useState, useEffect } from 'react';
import Layouts from '../components/Layouts';
import {
  Form,
  Col,
  Row,
  Table,
  Input,
  Tooltip,
} from 'antd';
import { Spin, Tag } from 'antd';
import apiRequest from '../hooks/apiRequest';
export default function AuditTrial() {
  const [resData, setresData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterTable, setFilterTable] = useState([]);
  const columns = [
    {
      title: 'Approver',
      dataIndex: 'approvedByUserName',
      key: '1',
    },
    {
      title: 'Date Time Of Approval',
      dataIndex: 'dateOfApproval',
      key: '3',
    },
    {
      title: 'Notes',
      dataIndex: 'approvalComment',
      key: '5',
    },
    // {
    //   key: '12',
    //   title: 'Action',
    //   render: (record) => (
    //   )
    // }
  ]

  useEffect(() => {
    const fetchClaims = async () => {
      setLoading(true)
      const url = process.env.REACT_APP_BASE_URL + '/Claim/GetAllApprovedClaims/approved-claims-with-audit'
      const response = await apiRequest(url, 'GET');
      console.log('response',response);
      
      if (!response.success) {
        console.error('API Error:', response.error || response.data)
        setLoading(false)
        return
      }
      const data = response.data?.data || []
      setresData(data)
      setLoading(false)
    }
    fetchClaims()
  }, [])

 
  const search = value => {
    const searchRes = resData.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setFilterTable([...searchRes])
  }

  return (
    <Layouts title="assets" classname="grid">
      <Spin
        className="loader-icon-fixed"
        spinning={loading}
        size="large"></Spin>
      <div>
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  {' '}
                  Audit Trial{' '}
                </h3>
              </div>
            </Col>
            <Col xs={12} sm={24} md={24} lg={8}>
              <div className="item-search">
                <Form.Item>
                  {' '}
                  <Input.Search
                    placeholder="Search ..."
                    enterButton
                    onSearch={search}
                  />{' '}
                </Form.Item>
              </div>
            </Col>
          </Row>
        </div>
        <div className="table-grid-bx">
          {' '}
          <Table
            columns={columns}
            dataSource={filterTable.length > 0 ? filterTable : resData}
            scroll={{
              x: 500,
            }}
          />
        </div>
      </div>
    </Layouts>
  )
}
